import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
/**
 * Utility function to determine if the current route is on the broker (dashboard) side
 *
 * @returns {boolean} true if current route contains '/dashboard'
 */
export var isBrokerSide = function isBrokerSide() {
  var _context;
  if (typeof window === "undefined") {
    return false;
  }
  return _includesInstanceProperty(_context = window.location.pathname).call(_context, "/dashboard");
};

/**
 * Utility function to determine if the current route is on the client side
 *
 * @returns {boolean} true if current route does not contain '/dashboard'
 */
export var isClientSide = function isClientSide() {
  return !isBrokerSide();
};